"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VelodromeV2PoolCode = void 0;
const chain_1 = require("@zenlink-interface/chain");
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const viem_1 = require("viem");
const HEXer_1 = require("../../HEXer");
const PoolCode_1 = require("./PoolCode");
class VelodromeV2PoolCode extends PoolCode_1.PoolCode {
    constructor(pool, providerName) {
        super(pool, providerName);
        this.executor = {
            [chain_1.ParachainId.BASE]: '0x1B5a2f88420ff329406D108e641e52E46465F68e',
            [chain_1.ParachainId.SCROLL]: '0x7b3f25a62F3557661812Ee91d9552d6fb6a57EDd',
        };
    }
    getProtocolExecutor() {
        const chainId = this.pool.token0.chainId;
        (0, tiny_invariant_1.default)(chainId !== undefined, 'VelodromeV2PoolCode: Unseted chainId');
        return this.executor[Number(chainId)];
    }
    getProtocolExecutorStartPoint() {
        return this.pool.address;
    }
    getSwapCodeForRouteProcessor(_leg, _route, _to) {
        return 'unsupported';
    }
    getSwapCodeForRouteProcessor2(_leg, _route, _to) {
        return 'unsupported';
    }
    getSwapCodeForAggregationRouter(leg, _route, to) {
        const code = new HEXer_1.HEXer()
            .address(this.getProtocolExecutor())
            .bytes((0, viem_1.encodeAbiParameters)((0, viem_1.parseAbiParameters)('address, uint8, address'), [
            this.pool.address,
            leg.tokenFrom.address === this.pool.token0.address ? 1 : 0,
            to,
        ]))
            .toString();
        return code;
    }
}
exports.VelodromeV2PoolCode = VelodromeV2PoolCode;
